import { cookieManager } from "@/service/cookieManager";
import store from "@/store/index";
import { detectOS } from "@/utils/commonUtils";

const state = {
	isConnected: false,
	socket: null,
	messages: [],
};

const getters = {
	isConnected: (state) => state.isConnected,
	messages: (state) => state.messages,
	trafficLightStatus: (state) => {
		return state.isConnected ? "green" : "red";
	},
};

const mutations = {
	SET_CONNECTED(state, status) {
		state.isConnected = status;
	},
	SET_SOCKET(state, socket) {
		state.socket = socket;
	},
	ADD_MESSAGE(state, message) {
		state.messages.push(message);
	},
	CLEAR_MESSAGES(state) {
		state.messages = [];
	},
};

const actions = {
	connectToWebSocket({ commit, dispatch }) {
		return new Promise((resolve, reject) => {
			try {
				const socket = new WebSocket("ws://localhost:7007"); // Use the global WebSocket

				socket.onopen = () => {
					console.log("WebSocket connection established");
					commit("SET_CONNECTED", true);
					commit("SET_SOCKET", socket);

					dispatch("sendMessage", { action: "GET_VERSION", data: null });
					resolve(); // Resolve the promise if connected
				};

				socket.onmessage = (event) => {
					console.log("Message received:", event.data);
					commit("ADD_MESSAGE", event.data);
					dispatch("handleIncomingMessage", event.data);
				};

				socket.onerror = (error) => {
					console.error("WebSocket error:", error);
					commit("SET_CONNECTED", false);
					reject(error); // Reject the promise on error
				};

				socket.onclose = () => {
					console.log("WebSocket connection closed");
					commit("SET_CONNECTED", false);
					commit("SET_SOCKET", null);
					reject(new Error("WebSocket connection closed")); // Reject if closed unexpectedly
				};
			} catch (error) {
				console.error("Error connecting to WebSocket:", error);
				reject(error); // Reject the promise if there's an error during creation
			}
		});
	},

	checkAndConnectToWeWingman({ state, dispatch }) {
		if (state.isConnected) {
			console.log("WeWingman is already connected.");
			testAppDeepLink(store);
			return;
		}

		console.log("Attempting to connect to WebSocket...");
		dispatch("connectToWebSocket")
			.then(() => {
				console.log("WebSocket connection established successfully.");
			})
			.catch(() => {
				console.warn("Error conectando a websocket. Intentando abrir servicio de impresión WeWelcom...");
				testAppDeepLink(store);
			});
	},
	async openCashDrawer({ dispatch }) {
		if (state.isConnected) {
			await dispatch("sendMessage", { action: "OPEN_CASH_DRAWER", data: {} });
		} else {
			//await dispatch("copilot/showToastError", {message: "No hay conexión con la impresora"}, { root: true });
		}
	},
	async printBill({ dispatch }, payload) {
		const bill = payload.bill;
		const openCashDrawer = payload.openCashDrawer ?? false;

		if (!bill || !bill.id) {
			console.warn("No bill provided to printBill");
			return;
		}

		console.log("id bill", bill);
		const data = {
			id: bill.id,
		};
		let billPrintInfoResult = await dispatch("copilot/getBillPrintInfo", data, { root: true });

		const currentOS = detectOS();
		console.log("vamos a imprimir en bill" + currentOS);

		let options = {
			message: billPrintInfoResult.escPosText,
			cut: true,
			printLogo: false,
			postFeedMm: 0,
			openCashDrawer: openCashDrawer,
		};

		let printData = {
			message: billPrintInfoResult.escPosText,
			options: options,
			cut: true,
			printLogo: false,
			postFeedMm: 0,
		};

		dispatch("sendMessage", { action: "PRINT", data: printData });
	},

	async printBatch({ dispatch }, payload) {
		const { jobs } = payload;
		dispatch("sendMessage", { action: "PRINT_BATCH", data: { jobs } });
	},

	async buildBatchPayload(vouchers, common = {}) {
		// vouchers = Array<string>   (your escPosText array)
		// common   = options to merge into each job (cut, logo, ...)
		const jobs = vouchers.map((text) => ({
			message: text,
			options: { cut: true, ...common }, // merge any overrides
		}));

		return { action: "PRINT_BATCH", data: { jobs } };
	},

	async printText({ dispatch }, escPosText) {
		const currentOS = detectOS();
		console.log("vamos a imprimir en text" + currentOS);

		let printData = {
			message: escPosText,
			cut: true,
			printLogo: false,
			postFeedMm: 0,
		};

		dispatch("sendMessage", { action: "PRINT", data: printData });
	},
	disconnectWebSocket({ state, commit }) {
		if (state.socket) {
			state.socket.close();
			commit("SET_CONNECTED", false);
			commit("SET_SOCKET", null);
			console.log("WebSocket connection closed by client");
		}
	},
	sendMessage({ state }, { action, data }) {
		if (state.socket && state.isConnected) {
			const message = JSON.stringify({ action, data });
			state.socket.send(message);
		} else {
			console.error("WebSocket is not connected");
		}
	},
	handleIncomingMessage(_, message) {
		try {
			const { status, data, message: serverMessage } = JSON.parse(message);

			console.log("Server Response:", { status, data, serverMessage });

			if (status === "success") {
				// Handle successful responses

				switch (data.action) {
					case "GET_VERSION":
						console.log("Server version:", data.version);
						break;
					case "LIST_PRINTERS":
						console.log("Available printers:", data.printers);
						break;
					default:
						console.warn("Unhandled successful action:", data);
				}
			} else if (status === "error") {
				// Handle error responses
				console.error("Error from server:", serverMessage);
			} else {
				console.warn("Unknown status received:", status);
			}
		} catch (error) {
			console.error("Error parsing server message:", error);
		}
	},
	downloadApk({ rootGetters }) {
		const venueWewelcomUrl = rootGetters["venue/urlVenue"];
		const apkUrl = `${venueWewelcomUrl}/world/api/wewingman/download`;
		console.log("WeWingman download URL:", apkUrl);

		const token = cookieManager.getToken();

		fetch(apkUrl, {
			method: "GET",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error("Failed to download APK");
				}

				// Extract filename from the response headers
				const disposition = response.headers.get("Content-Disposition");
				let filename = "download.apk"; // fallback name

				if (disposition && disposition.includes("filename=")) {
					const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
					if (filenameMatch.length > 1) {
						filename = filenameMatch[1];
					}
				}

				return response.blob().then((blob) => ({ blob, filename }));
			})
			.then(({ blob, filename }) => {
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement("a");
				a.href = url;
				a.download = filename; // use filename from server
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				window.URL.revokeObjectURL(url);
				console.log(`APK downloaded successfully as ${filename}`);
			})
			.catch((error) => {
				console.error("Error downloading APK:", error);
				alert("There was an issue downloading the APK. Please try again later.");
			});
	},
};
const testAppDeepLink = (store) => {
	let deepLinkOpened = false; // Track if the app was successfully opened

	// Create an invisible iframe to trigger the deep link
	const iframe = document.createElement("iframe");
	iframe.style.display = "none";
	iframe.src = "wewelcom://wewingman";

	document.body.appendChild(iframe);

	// Wait a short time to determine if the app is installed
	const timeout = setTimeout(() => {
		if (!deepLinkOpened) {
			// If the deep link did not open the app, assume it's not installed
			alert("El Servicio de impresión WeWelcom no está instalado. Intentando descargar la aplicación...");
			store
				.dispatch("weWingman/downloadApk")
				.then(() => {
					console.log("APK downloaded successfully");
				})
				.catch((error) => {
					console.error("Failed to download APK:", error);
					alert("Hubo un problema descargando la aplicación. Por favor, inténtelo más tarde.");
				});
		}
		document.body.removeChild(iframe); // Clean up the iframe
	}, 1000); // Adjust this timeout as necessary

	// Attempt to capture the focus event, which indicates the deep link worked
	window.addEventListener("blur", () => {
		deepLinkOpened = true; // App successfully opened
		clearTimeout(timeout); // Cancel the fallback logic
	});
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
